import { Link } from 'react-router-dom';

export default function About() {
  // Optimerer de uploadede billeder til Om os-siden
  const img1 = 'https://assets.auxodev.dk/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/672333970-1459533575965030-6383088530199860706-n.jpg';
  const img2 = 'https://assets.auxodev.dk/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/672330188-1459533669298354-5069136850237555422-n.jpg';
  
  const optimizedImg1 = img1.replace('assets.auxodev.dk/assets/', 'assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/');
  const optimizedImg2 = img2.replace('assets.auxodev.dk/assets/', 'assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/');

  return (
    <>
      {/* React 19 Native Metadata Hoisting */}
      <title>Om os - Nygaards Vinduespolering</title>
      <meta
        name="description"
        content="Læs om Nygaards Vinduespolering, en lokal vinduespudser i Kerteminde med fokus på kvalitet, grundighed og god service."
      />

      {/* Hero Header */}
      <section className="bg-slate-50/70 py-20 border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
            Hvem står bag?
          </span>
          <h1 className="mt-3 font-display text-3xl font-bold uppercase tracking-wider text-brand-blue sm:text-4xl">
            Om Nygaards Vinduespolering
          </h1>
          <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
          <p className="mx-auto mt-6 max-w-2xl text-sm font-light leading-relaxed text-slate-500">
            Din lokale vinduespudser i Kerteminde, der sætter en ære i det gode håndværk og den personlige kontakt.
          </p>
        </div>
      </section>

      {/* Introduktion Sektion */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
            {/* Tekst */}
            <div className="lg:col-span-7">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                Lokal service
              </span>
              <h2 className="mt-2 font-display text-2xl font-bold uppercase tracking-wider text-brand-dark">
                Lokal forankring og personlig service
              </h2>
              <p className="mt-6 text-sm font-light leading-relaxed text-slate-500">
                Nygaards Vinduespolering er stiftet med en klar vision: At levere en vinduespudserservice i særklasse til private, erhverv og ejendomme i Kerteminde og omegn. Som en lokal virksomhed vægter vi den tætte dialog og den personlige relation til vores kunder utrolig højt.
              </p>
              <p className="mt-4 text-sm font-light leading-relaxed text-slate-500">
                Vi ved, at rene ruder gør en enorm forskel for både lysindfaldet i dit hjem og det professionelle førstehåndsindtryk af din virksomhed. Derfor går vi altid grundigt til værks og efterlader ingen striber eller pletter.
              </p>

              <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2">
                <div className="flex gap-4">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue">
                    <i className="fa-solid fa-award" />
                  </div>
                  <div>
                    <h3 className="font-display text-xs font-bold uppercase tracking-wider text-brand-dark">Høj kvalitet</h3>
                    <p className="mt-1 text-xs font-light text-slate-500">Vi pudser med stor omhu og præcision hver eneste gang.</p>
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue">
                    <i className="fa-solid fa-clock" />
                  </div>
                  <div>
                    <h3 className="font-display text-xs font-bold uppercase tracking-wider text-brand-dark">Punktlighed</h3>
                    <p className="mt-1 text-xs font-light text-slate-500">En aftale er en aftale. Vi kommer til tiden som aftalt.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Billede */}
            <div className="lg:col-span-5">
              <div className="relative aspect-4/3 overflow-hidden rounded-none bg-slate-100 shadow-none">
                <img
                  src={optimizedImg1}
                  alt="Nygaards Vinduespolering udstyr og bil"
                  className="h-full w-full object-cover rounded-none"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vores Værdier Sektion */}
      <section className="bg-slate-50/70 py-20 border-t border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
            {/* Billede */}
            <div className="lg:col-span-5 order-last lg:order-first">
              <div className="relative aspect-4/3 overflow-hidden rounded-none bg-slate-100 shadow-none">
                <img
                  src={optimizedImg2}
                  alt="Nygaards Vinduespolering i gang med at pudse vinduer"
                  className="h-full w-full object-cover rounded-none"
                />
              </div>
            </div>

            {/* Tekst */}
            <div className="lg:col-span-7">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                Vores værdier
              </span>
              <h2 className="mt-2 font-display text-2xl font-bold uppercase tracking-wider text-brand-dark">
                Kvalitet, grundighed og god kundeservice
              </h2>
              <p className="mt-6 text-sm font-light leading-relaxed text-slate-500">
                Vi tror på, at den bedste markedsføring er et veludført stykke arbejde og en tilfreds kunde. Derfor går vi aldrig på kompromis med kvaliteten af vores vinduespolering. Vi anvender professionelt udstyr, herunder moderne rentvandsanlæg og traditionelle metoder, der skåner både dine vinduer og naturen.
              </p>
              <p className="mt-4 text-sm font-light leading-relaxed text-slate-500">
                Vi tilbyder skræddersyede løsninger til:
              </p>
              <ul className="mt-4 space-y-2.5 text-xs font-light text-slate-500">
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span><strong>Private hjem:</strong> Huse, lejligheder, villaer og sommerhuse (frit valg af metode).</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span><strong>Erhverv:</strong> Kontorer, butikker, klinikker og erhvervsejendomme (rentvandsanlæg eller traditionel).</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span><strong>Kirker & historiske bygninger:</strong> Vi er specialister i nænsom og professionel vinduesvask af kirker.</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span><strong>Ejendomme:</strong> Boligforeninger og trappeopgange.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Sektion */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8">
          <h2 className="font-display text-2xl font-bold uppercase tracking-wider text-brand-dark">
            Lad os tage os af dine vinduer
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-xs font-light leading-relaxed text-slate-500">
            Kontakt os i dag for at høre mere om vores ydelser eller for at få et uforpligtende tilbud på vinduespolering eller tagrenderensning.
          </p>
          <div className="mt-8 flex justify-center">
            <Link
              to="/kontakt"
              className="rounded-full bg-brand-blue px-8 py-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-brand-orange transition-all duration-300 hover:scale-105"
            >
              Få et uforpligtende tilbud
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
